import Image from "next/image";
import { styled } from "@mui/system";
import { Container, Grid, Typography } from "@mui/material";

import diploma from "../../../assets/imgs/main-website/icons/diploma.png";
import elearning from "../../../assets/imgs/main-website/icons/elearning.png";
import teacher from "../../../assets/imgs/main-website/icons/teacher.png";
import styles from "./BenifitsOfTeaching.module.css";

const BenifitsOfTeaching = () => {
  return (
    <Container disableGutters sx={{ mt: 10 }}>
      <Typography
        variant="h4"
        sx={{
          fontSize: "48px",
          textAlign: "center",
          fontWeight: "600",
        }}
      >
        Several Reasons to Begin
      </Typography>
      <Grid container justifyContent="center" spacing={3} sx={{ mt: 3 }}>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={teacher} />
          </div>
          <p>Teach on Your Own Terms</p>
          <span>
            Create and manage your own live or pre-recorded courses with your
            own contents at your preferred schedule.
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={elearning} />
          </div>
          <p>Global Learners</p>
          <span>
            Reach out to thousands of learners already using Takbir for
            knowledge or invite your own learners and followers within one
            platform.
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={diploma} />
          </div>
          <p>Worth Sharing</p>
          <span>
            Your unique knowledge, expertise, and wisdom are worth sharing to
            make a profound impact with the global community.
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={teacher} />
          </div>
          <p>Acknowledgement for your efforts</p>
          <span>
            Recognize the value of your time and efforts with compensation for
            each paid enrollment in your courses.
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={diploma} />
          </div>
          <p>Inspire Learners</p>
          <span>
            Share your knowledge and ignite curiosity about Deen, encouraging
            learners to explore and delve deeper into teachings of Islam.
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={elearning} />
          </div>
          <p>Continue the Legacy of Prophet (PBUH)</p>
          <span>
            Uphold Prophet Muhammad's (PBUH) legacy by spreading His teachings,
            and contributing to a world marked by compassion (Rahma), wisdom
            (Hikmah), and harmony (Salam).
          </span>
        </StyledGridRow>
        <StyledGridRow item xs={12} md={4} className={styles.itemContainer}>
          <div className={styles.imgcontainer}>
            <Image src={teacher} />
          </div>
          <p> Teaching Resource and Success Team (TRST)</p>
          <span>
            Team up with our skilled Teaching Resource and Success Team (TRST)
            to receive dedicated support at every step of your teaching journey.
          </span>
        </StyledGridRow>
      </Grid>
    </Container>
  );
};

export default BenifitsOfTeaching;

const StyledGridRow = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {},
}));
